import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const Input = React.memo(
  ({
    className,
    name,
    value,
    onChange,
    onBlur,
    autoComplete,
    isDisabled,
    readOnly,
    type,
    tabIndex,
    placeholder,
    defaultValue,
    onClick,
    maxLength,
  }) => {
    return (
      <div className={styles.inputWrapper}>
        <input
          className={`${styles.input}${className ? ` ${className}` : ''}`}
          disabled={isDisabled}
          readOnly={readOnly}
          autoComplete={autoComplete}
          type={type}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          defaultValue={defaultValue}
          tabIndex={tabIndex}
          placeholder={placeholder}
          onClick={onClick}
          maxLength={maxLength}
        />
      </div>
    );
  }
);

Input.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  isDisabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  autoComplete: PropTypes.string,
  type: PropTypes.string,
  tabIndex: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  maxLength: PropTypes.number,
};

Input.displayName = 'Input';

export default Input;
